var _desc, _defs, _path, _path2, _path3, _g, _g2, _g3, _g4, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g5, _path20, _g6, _path21, _path22, _g7, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect3, _path38, _path39, _path40, _path41, _path42, _rect4, _ellipse, _path43, _path44, _path45, _path46, _rect5, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _ellipse2, _ellipse3, _path66, _path67, _path68, _path69, _path70, _path71, _ellipse4, _ellipse5, _rect6, _ellipse6, _rect7, _ellipse7, _rect8, _ellipse8, _rect9, _ellipse9, _rect10, _path72, _path73, _path74;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkflowBannerImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 380",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: "49.99%",
    x2: "49.99%",
    y1: "250.15%",
    y2: "-169.99%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: "49.951%",
    x2: "49.951%",
    y1: "250.11%",
    y2: "-169.97%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: ".01588%",
    x2: "100.01%",
    y1: "50.003%",
    y2: "50.003%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D3BA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C5AC",
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A189",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: "31.282%",
    x2: "104.47%",
    y1: "108.31%",
    y2: "-127.8%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA8F",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: "70.783%",
    x2: "-17.58%",
    y1: "56.309%",
    y2: "35.56%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D3BA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C5AC",
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A189",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: "55.316%",
    x2: "11.278%",
    y1: "64.522%",
    y2: "-97.648%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD087",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC770",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: "82.964%",
    x2: "10.576%",
    y1: "105.6%",
    y2: "-16.501%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004B87",
    offset: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00295D",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "34.53%",
    x2: "63.407%",
    y1: "128.44%",
    y2: "-17.999%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB699",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47E6D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "24.266%",
    x2: "74.91%",
    y1: "91.772%",
    y2: "9.5312%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB699",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47E6D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: "14.481%",
    x2: "71.769%",
    y1: "26.72%",
    y2: "77.657%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE28",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9328",
    offset: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B03400",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: "172.16%",
    x2: "26.904%",
    y1: "130.8%",
    y2: "34.722%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004B87",
    offset: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00295D",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: "38.35%",
    x2: "68.106%",
    y1: "119.84%",
    y2: "-50.364%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE28",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9328",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B03400",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: "49.99%",
    x2: "49.99%",
    y1: "322.95%",
    y2: "-127.78%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE28",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9328",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B03400",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: "50.001%",
    x2: "50.001%",
    y1: "212.77%",
    y2: "2.01%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4900",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#862600",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: "86.273%",
    x2: "32.487%",
    y1: "31.766%",
    y2: "75.226%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB699",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47E6D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: "54.915%",
    x2: "47.13%",
    y1: "123.97%",
    y2: "-1.5213%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB699",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47E6D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: "49.988%",
    x2: "49.988%",
    y1: "414.95%",
    y2: "10.51%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4900",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#862600",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: "255.28%",
    x2: "13.595%",
    y1: "104.82%",
    y2: "43.283%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4900",
    offset: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#862600",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: "157.31%",
    x2: "-61.622%",
    y1: "176.89%",
    y2: "-62.838%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB699",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47E6D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: "113.01%",
    x2: "252.05%",
    y1: "72.967%",
    y2: "127.22%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4900",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#862600",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: "265.34%",
    x2: "-12.739%",
    y1: "33.205%",
    y2: "51.426%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4900",
    offset: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#862600",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: "46.761%",
    x2: "74.303%",
    y1: "48.572%",
    y2: "65.262%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4900",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#862600",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: "50%",
    x2: "50%",
    y1: "322.99%",
    y2: "-127.8%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE28",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9328",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B03400",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: "21.447%",
    x2: "70.625%",
    y1: "-96.112%",
    y2: "193.68%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB699",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47E6D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: "184.38%",
    x2: "-89.716%",
    y1: "17.896%",
    y2: "76.478%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC8127",
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996027",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3920",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: "53.046%",
    x2: "44.72%",
    y1: "116.91%",
    y2: "-3.0617%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC8127",
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996027",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3920",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: "50.068%",
    x2: "50.068%",
    y1: "213.18%",
    y2: "1.9743%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4900",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#862600",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: "50.043%",
    x2: "50.043%",
    y1: "212.7%",
    y2: "2.0203%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4900",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#862600",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: "64.301%",
    x2: "42.462%",
    y1: "3.62%",
    y2: "74.691%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB699",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47E6D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: ".044596%",
    x2: "99.912%",
    y1: "49.907%",
    y2: "49.907%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03153B",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: "-69.956%",
    x2: "111.04%",
    y1: "178.33%",
    y2: "-14.986%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC474",
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B277",
    offset: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: "86.784%",
    x2: "31.266%",
    y1: "59.914%",
    y2: "37.576%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEE2",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ADBE",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: "33.222%",
    x2: "54.476%",
    y1: "-95.787%",
    y2: "83.3%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB699",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47E6D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: "38.062%",
    x2: "79.258%",
    y1: "133.36%",
    y2: "-22.439%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEE2",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ADBE",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: "60.231%",
    x2: "37.379%",
    y1: "74.49%",
    y2: "32.875%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#485BBC",
    offset: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362B96",
    offset: 0.77
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: "69.023%",
    x2: "11.957%",
    y1: "65.198%",
    y2: "28.195%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEE2",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ADBE",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: "27.326%",
    x2: "92.899%",
    y1: "36.302%",
    y2: "83.715%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEE2",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ADBE",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: "28.198%",
    x2: "68.073%",
    y1: "123.36%",
    y2: "-15.535%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEE2",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ADBE",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: "80.933%",
    x2: "-151.35%",
    y1: "45.125%",
    y2: "74.056%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEE2",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ADBE",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: "76.175%",
    x2: "13.986%",
    y1: "-17.101%",
    y2: "131.72%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95D32",
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB1A28",
    offset: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "49.976%",
    x2: "50.091%",
    y1: "55.209%",
    y2: "-25.943%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95D32",
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB1A28",
    offset: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: "22%",
    x2: "60%",
    y1: "8642.5%",
    y2: "-3035.5%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95D32",
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB1A28",
    offset: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: "40.079%",
    x2: "54.762%",
    y1: "4304.9%",
    y2: "-1390.7%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95D32",
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB1A28",
    offset: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: "33.5%",
    x2: "54.5%",
    y1: "5199%",
    y2: "-1226%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95D32",
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB1A28",
    offset: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: "50%",
    x2: "50%",
    y1: "278.12%",
    y2: "-211.94%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: "48.646%",
    x2: "53.148%",
    y1: "85.911%",
    y2: "-31.31%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: "70.111%",
    x2: "32.031%",
    y1: "174.21%",
    y2: "-59.871%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: "59.027%",
    x2: "38.996%",
    y1: "111.27%",
    y2: "-6.7914%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: "74.744%",
    x2: "3.8902%",
    y1: "-102.46%",
    y2: "344.87%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD087",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC770",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: "60.335%",
    x2: "35.283%",
    y1: "24.866%",
    y2: "186.72%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD087",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC770",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: "-.0058917%",
    x2: "99.939%",
    y1: "50.006%",
    y2: "50.006%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE49F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E9CA",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: "91.21%",
    x2: "-52.354%",
    y1: "29.763%",
    y2: "104.84%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA8F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: "67.685%",
    x2: "24.569%",
    y1: "98.616%",
    y2: "-38.746%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#847AB8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B61A3",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: "-10.139%",
    x2: "165.76%",
    y1: "54.275%",
    y2: "39.392%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#847AB8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C93C7",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: "-.0064047%",
    y1: "49.987%",
    y2: "49.987%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD087",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC770",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: "93.552%",
    x2: "-44.429%",
    y1: "179.84%",
    y2: "-231.31%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "221.16%",
    y2: "-157.03%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "36.898%",
    x2: "62.679%",
    y1: "43.358%",
    y2: "56.167%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D2900",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#822B00",
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923000",
    offset: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973200",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: "37.177%",
    x2: "63.155%",
    y1: "43.358%",
    y2: "56.167%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D2900",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#822B00",
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923000",
    offset: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973200",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "36.898%",
    x2: "62.837%",
    y1: "43.358%",
    y2: "56.167%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D2900",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#822B00",
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923000",
    offset: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973200",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: "37.176%",
    x2: "63.154%",
    y1: "43.506%",
    y2: "56.316%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D2900",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#822B00",
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923000",
    offset: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973200",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: "36.74%",
    x2: "62.522%",
    y1: "43.358%",
    y2: "56.167%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D2900",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#822B00",
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923000",
    offset: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973200",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: "98.312%",
    x2: "-30.621%",
    y1: "99.589%",
    y2: "-94.81%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA8F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: "103.75%",
    x2: "-41.643%",
    y1: "72.753%",
    y2: "4.5556%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA8F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: "48.107%",
    x2: "56.818%",
    y1: "24.013%",
    y2: "75.813%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E241C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721A14",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: "77.906%",
    x2: "44.464%",
    y1: "105.83%",
    y2: "11.188%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E241C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721A14",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: ".014761%",
    x2: "100.01%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E241C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721A14",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: "-561.04%",
    x2: "3134.5%",
    y1: "1738.5%",
    y2: "-8467.5%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: "16.79%",
    x2: "44.967%",
    y1: "167.36%",
    y2: "53.276%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E241C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721A14",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: "55.439%",
    x2: "33.742%",
    y1: "62.204%",
    y2: "-4.9452%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: "25.642%",
    x2: "37.078%",
    y1: "28.263%",
    y2: "44.213%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E241C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721A14",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: "87.767%",
    x2: "53.556%",
    y1: "52.776%",
    y2: "50.315%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#571A14",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E241C",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: "109.93%",
    x2: "-41.419%",
    y1: "79.614%",
    y2: "-7.6946%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA8F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: "114.95%",
    x2: "25.549%",
    y1: "40.406%",
    y2: "50.717%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E241C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721A14",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: "58.709%",
    x2: "-7.3734%",
    y1: "81.779%",
    y2: "-31.093%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E241C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721A14",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: "49.983%",
    x2: "49.983%",
    y1: "107.37%",
    y2: "11.969%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: "54.559%",
    x2: "32.804%",
    y1: "101.75%",
    y2: "-.061626%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A887",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#256351",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: "-.10163%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6CB1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7BBB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: "50.007%",
    x2: "50.007%",
    y1: "131.07%",
    y2: "-57.458%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: "50.012%",
    x2: "50.012%",
    y1: "131.07%",
    y2: "-57.465%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDFEC",
    offset: 0.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: "50.588%",
    x2: "49.378%",
    y1: "52.103%",
    y2: "47.778%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A887",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#256351",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: "45.281%",
    x2: "53.279%",
    y1: "53.224%",
    y2: "46.354%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A887",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#256351",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: "100.5%",
    x2: "-17.984%",
    y1: "95.945%",
    y2: "-12.498%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA8F",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: "86.132%",
    x2: "-7.4703%",
    y1: "11.248%",
    y2: "118.34%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA8F",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "-.00076313%",
    y1: "50.003%",
    y2: "50.003%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6CB1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7BBB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: "50.332%",
    x2: "47.745%",
    y1: "73.388%",
    y2: "-114.49%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6CB1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7BBB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "71.718%",
    x2: "-3.9832%",
    y1: "73.12%",
    y2: "5.2489%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6CB1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7BBB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "43.475%",
    x2: "72.375%",
    y1: "74.847%",
    y2: "-41.102%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273D3C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314341",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "39.231%",
    x2: "64.231%",
    y1: "107.88%",
    y2: "-45.131%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273D3C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314341",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "-4.5548e-14%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6CB1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7BBB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6CB1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7BBB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "176.15%",
    y2: "-127.89%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A887",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#256351",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "49.995%",
    x2: "49.995%",
    y1: "86.782%",
    y2: "-108.04%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A887",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#256351",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: ".021048%",
    x2: "100.01%",
    y1: "49.993%",
    y2: "49.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4F11",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6C18",
    offset: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27C1C",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34 17)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m137.95 70h630.86",
    stroke: "#D8D8D8",
    strokeDasharray: "0,20",
    strokeLinecap: "round",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m248 259h328.5",
    stroke: "#D8D8D8",
    strokeDasharray: "0,20",
    strokeLinecap: "round",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m218 270v-214",
    stroke: "#D8D8D8",
    strokeDasharray: "0,20",
    strokeLinecap: "round",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(762 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.351,
    y: 93.057,
    width: 29.093,
    height: 11.201,
    rx: 5.6006,
    fill: "url(#cp)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.783 131.19v-26.066h-2.9457v26.066c0 0.883-0.34884 1.7298-0.96978 2.3542-0.62094 0.62437-1.4631 0.97514-2.3412 0.97514h-2.4921c-0.93546 0-1.6938 0.76254-1.6938 1.7032v0.78198h17.969v-0.78198c0-0.94064-0.75834-1.7032-1.6938-1.7032h-2.5127c-0.87967 0.002361-1.7241-0.34736-2.347-0.97199-0.62285-0.62463-0.9729-1.4728-0.9729-2.3573z",
    fill: "url(#ce)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.046 9.444-19.585 10.854c-0.56478 0.31311-0.98111 0.84021-1.156 1.4636s-0.093784 1.2911 0.22521 1.854l10.375 18.308c0.31898 0.56715 0.85208 0.98145 1.479 1.1494s1.2948 0.075398 1.8529-0.25677l19.232-11.473c1.1267-0.67363 1.5111-2.1272 0.86557-3.273l-10.028-17.704c-0.65302-1.1504-2.1053-1.5612-3.2607-0.92238z",
    fill: "#1A305D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.77 28.641s-2.8961-3.6151-1.5711-7.3761c1.325-3.7609 1.5978-0.39573 1.5711 0.5207-0.026679 0.91643 0.47725 1.5621 2.1402 3.9067 1.663 2.3446-1.5059 4.2102-1.5059 4.2102l-0.63436-1.2616z",
    fill: "#F9AA8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.447 25.547s-8.1251 14.761-17.537 0.1458l-1.9209 4.1954c-0.72862 1.5796-0.49866 3.4378 0.59286 4.7904 2.8042 3.4515 9.6369 9.0126 23.744 7.0875 29.859-4.0793-4.8792-16.219-4.8792-16.219z",
    fill: "#40D3BA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.447 25.547s-8.1251 14.761-17.537 0.1458l-1.9209 4.1954c-0.72862 1.5796-0.49866 3.4378 0.59286 4.7904 2.8042 3.4515 9.6369 9.0126 23.744 7.0875 29.859-4.0793-4.8792-16.219-4.8792-16.219z",
    fill: "url(#bt)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.283 19.519-6.7408 3.7371",
    stroke: "#345082",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.676 22.399-6.7408 3.7371",
    stroke: "#345082",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.072 25.276-6.7437 3.7401",
    stroke: "#345082",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.912 41.314s-0.7055-3.1659-2.9109-2.7255c-4.1085 0.82419-7.2002-6.6263-6.059 1.4609 0.78257 5.5581 7.2477 5.6533 7.2477 5.6533l1.7222-4.3888z",
    fill: "#F9AA8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.511 19.569c-0.87501-1.9789-0.93573-4.2247-0.16896-6.2484 0.52804-1.4944 0.70556-3.091 0.51875-4.6655-0.59286-5.2546-4.9444-9.0661-9.6873-8.5157-3.6164 0.41954-6.4236 3.2581-7.2862 6.9119 0 0-1.7163 7.0309-0.53061 7.0845h0.415c0.56928 0.0050304 1.0953 0.30565 1.3902 0.79444 1.1871 1.9689 3.0789 3.408 5.2883 4.0228 0.36724 0.094342 0.67022 0.35412 0.82045 0.70346 0.15023 0.34934 0.13077 0.74883-0.052705 1.0818-0.57507 0.96999-1.4021 1.4877-1.2272 2.4726 1.5296 8.6942 13.114 5.0582 14.451 0.95214-1.7039-1.142-3.0634-2.7309-3.9306-4.5941z",
    fill: "#F9AA8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.135 21.846 0.9545-3.4455c-0.43451-1.6796-0.34449-3.4526 0.25789-5.0791 0.27288-0.76894 0.45204-1.5682 0.53357-2.3803l-10.449-6.8316-4.9059-0.59509c-0.77203 1.0545-1.3236 2.2549-1.6215 3.5289 0 0-0.023714 0.10116-0.065214 0.27374 0.36544 0.25489 0.78248 0.42558 1.2213 0.49987 0.69957 0.077361-0.31125 2.7344-0.69957 4.8827-0.19268 1.0712-0.54246 1.3836-0.84482 1.4312h0.27271c0.56928 0.0050304 1.0953 0.30565 1.3902 0.79444 0.19865 0.31871 0.4154 0.62569 0.64918 0.91941-0.056321-0.14282-1.6689-4.2192 0.86854-6.4299 2.5819-2.2494 4.5531 6.7572 3.7735 8.1646-0.61954 1.1158-1.6244 0.74386-2.0157 0.54153 0.63104 0.36269 1.3067 0.64078 2.0098 0.82717 0.049328 0.012918 0.097833 0.028816 0.14525 0.047607 0.25789 0.068435 0.53357 0.13092 0.83 0.18448 1.9861 0.3511 1.8675 2.6571 1.8675 2.6571l5.8278 0.0089263z",
    fill: "url(#bi)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.294 72.196s-67.26-8.5216-73.25 51.844l3.9544-0.029755s11.78-24.851 38.02-28.365c13.713-1.8358 14.4 2.2673 31.276-23.449z",
    fill: "#5858A5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.115 124.04h4.064c-1.2154-3.7937-5.5847-17.618-7.4878-26.127-1.5474-6.9238 45.226 7.7718 50.603-22.241 0-0.0029755-99.92-18.046-47.18 48.369z",
    fill: "#6161AD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.292 32.626c-0.23714-0.69923-1.0108-2.9487-2.075-5.5551-0.15711-0.43441-0.332-0.84502-0.51579-1.2378-1.9831-4.6446-4.7073-9.7654-6.8505-9.1435-6.7941 2.0084-9.542 6.0729-9.9422 6.7215-0.059286 0.095214-0.11857 0.18745-0.18082 0.27969-0.19268 0.29754-0.40314 0.57128-0.61361 0.848-2.0187 2.6779-3.489 6.4507-3.8536 7.1619 0 0 4.1055-3.2998 2.0098 5.2546-2.487 10.155-5.7359 19.123-8.0391 30.611-1.6867 8.4175-2.075 10.435-2.075 14.148 0 13.059 12.883 2.3803 32.311 2.3803 17.323 0.014877 6.4325-34.223-0.17489-51.469z",
    fill: "#40D3BA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.292 32.626c-0.23714-0.69923-1.0108-2.9487-2.075-5.5551-0.15711-0.43441-0.332-0.84502-0.51579-1.2378l-0.19268-0.44929-4.0729-0.96404-20.75 32.67c0.050393-0.026779 12.577-7.141 17.237-0.79444 4.6599 6.3466-5.7715 16.755-21.046 18.117-0.57507 3.1926-0.74107 4.8916-0.74107 7.2987 0 13.059 12.883 2.3803 32.311 2.3803 17.344 0.017853 6.4532-34.22-0.15414-51.466z",
    fill: "url(#ax)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.578 31.075c-4.7429 9.078-15.924 26.092-33.668 10.185l-2.8457 3.2462c-0.92572 1.0468-0.89213 2.6326 0.077072 3.639 6.4295 6.6888 30.648 27.184 54.567-13.755 6.3762-10.917-2.6234-10.95-9.379-9.7416-3.7489 0.67155-6.9785 3.0436-8.7506 6.4269z",
    fill: "#40D3BA",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m47.255 6.1024c-0.39649 0.76425-0.16607 1.7032 0.53944 2.1983 1.1274 0.79525 2.9791 1.7901 4.8974 1.4937 2.5881-0.40216 3.1882 2.6095 3.47 4.0156 0.062837 0.34873 0.36616 0.60305 0.72128 0.60475 0.38517-5.257e-4 0.70487-0.2971 0.7334-0.68035 0.063642-0.87085 0.44247-2.3404 2.182-2.9179 2.5457-0.84666 3.267 3.3443 1.5911 5.9296-1.7517 2.7002 2.0305 0.39611 4.0034 1.0523 1.1365 0.37797 6.34-15.557-4.8005-17.514-8.4553-1.5119-12.083 3.3745-13.338 5.8177z",
    fill: "#FDC781",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7085 127.55-0.3098 7.0889-4.1204 2.3601h7.2679s0.10843-7.4422 1.2888-9.478",
    fill: "#40D3BA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "35.082 127.52 39.307 134.63 36.796 137 42.784 137 39.271 127.52",
    fill: "#40D3BA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.66 13.721c0.068801 0.37125 0.3899 0.63141 0.75027 0.60787s0.64811-0.32347 0.67234-0.7008c0.06211-0.89217 0.43181-2.3977 2.1295-2.9894 2.4844-0.86739 3.1883 3.4262 1.5527 6.0748-1.7095 2.7664 1.9816 0.40581 3.907 1.078 0.48209 0.16728 1.7154-2.8221 2.0703-6.4218-0.5442 3.2186-3.4486 2.8066-3.4012-1.9919 0.047322-4.7985-7.3053-7.0754-7.7992-2.8407-0.23365 2.0136-1.3664 2.788-2.4903 3.0606 1.8751 0.27261 2.3631 2.8469 2.6086 4.1232z",
    fill: "url(#ao)",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(162 176)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.631,
    y: 18.92,
    width: 9.4769,
    height: 17.2,
    rx: 4.7385,
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "72.369 150.5 76.744 163.4 80.123 163.4 78.024 152.57",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.869 153.18s-6.4619 6.7876-11.699 11.076h4.3942l17.144-12.04",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.369 152.22h7.5763c1.4387-0.00105 2.8387-0.45978 3.9922-1.3081 34.96-25.667 44.431-65.587 44.431-65.587s-37.803-30.892-31.833-3.4292c6.8984 31.882-15.16 60.314-24.167 70.324z",
    fill: "url(#co)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.354,
    y: 18.92,
    width: 9.4769,
    height: 17.2,
    rx: 4.7385,
    fill: "url(#cn)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.3077 6.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.171 86.732s3.76 4.3823 9.821 10.486c23.406 23.566 24.74 27.923 33.635 46.071 1.0349 2.1114 3.1672 3.4585 5.5133 3.483l5.5133 0.047915s-1.9407-21.654-21.296-64.275l-33.186 4.187z",
    fill: "url(#cm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.171 86.732s3.76 4.3823 9.821 10.486c5.2633 5.3001 9.4056 9.6234 12.776 13.357-0.49987-0.56023-4.9766-5.7866-4.6422-12.719 0.36755-7.3419 17.183-9.9072 17.183-9.9072l-21.726-2.9117-13.412 1.6954z",
    fill: "url(#cl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.51 32.291c0 0.20463-0.01303 0.40905-0.040443 0.61183-1.8378 13.106-4.2783 22.851-13.103 28.38-3.4807 2.1893-7.9575 3.7299-13.776 4.5703-3.8628 0.53803-7.2112 2.9549-8.9462 6.4574v0.044228c-0.19325 0.36833-0.36268 0.74874-0.50722 1.1389-2.3156 6.4869-7.917 14.828-21.638 14.828h-17.683c-5.7654 0.030223-11.484-1.0418-16.849-3.1593-5.7044-2.2888-11.762-6.1293-14.099-12.469-4.9472-13.353 16.139-33.743 16.139-33.743s33.815-35.833 49.16-9.0595c10.045 17.522 30.216 20.013 32.344 1.9534 0.26941-2.3727 2.3307-4.1273 4.7092-4.0084s4.2556 2.0703 4.2884 4.4581v-0.0036857z",
    fill: "url(#ck)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.946 23.832s13.669-6.5974 12.195-17.43l10.916-6.1072 3.341 11.684c0.26743 0.94805-0.2772 1.935-1.2203 2.2114-0.90193 0.26192-1.4942 1.1257-1.4151 2.064l1.3085 15.48-0.12129 6.7707-4.4694 2.4805-8.178-14.205-12.357-2.9486z",
    fill: "url(#cj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.956 19.534c-2.2053-3.037 0.28301-8.6467 2.6758-8.7904 1.7753-0.1032 2.1134 3.2471 2.1685 4.9868 0.13778-0.72881 0.67178-1.3184 1.382-1.5259 0.090913-0.028496 0.17941-0.064239 0.26464-0.10689-0.19848 0.066343-1.2828 0.36857-0.96298-0.95091 0.36755-1.4485-1.6907-5.4696-0.84537-5.4696 0.49252 0 0.98504-0.42017 1.3122-0.77031l-0.64689-2.2667-1.7936-3.166-10.332 5.3259c0.89682 8.7315-7.9869 14.636-11.14 16.442l-0.1801 0.80349 11.457 2.7274 5.12 8.8973 7.0129 3.1144 0.51457-0.2838 0.12129-6.7707-0.87109-10.302s-3.0396 1.1315-5.256-1.8945z",
    fill: "url(#ci)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.951 38.501-0.5403-14.57s4.282 6.8702 8.5198 11.595-18.153 18.429-18.723 17.655c-0.33815-0.44597-4.168-13.608-7.2665-24.348l-6.9835-5.0052c1.4942-0.73136 2.5577-2.1256 2.8706-3.7631 0.43739-2.3773 3.6167-3.1255 5.686-1.8834 4.9472 2.9854 12.144 9.0153 16.437 20.319z",
    fill: "url(#ch)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.977 82.35 4.587-6.2473s1.1835 1.1057-7.5164-5.7129c-8.6999-6.8186 3.3778-16.25 3.3778-16.25 0.051457-0.062657-0.055133 0.047914 0 0 5.5133-5.0826 13.548 1.6365 18.227 6.0519 3.0149 2.8522 3.9919 7.2589 2.4663 11.123l-0.61013 1.548c-1.0102 2.4646-1.659 5.063-1.926 7.7142-0.39548 4.4554-4.1143 7.8729-8.575 7.8801h-9.2182c-1.0075-6.446e-4 -1.929-0.56952-2.3833-1.4713-0.4543-0.90178-0.36415-1.9831 0.23315-2.7968l1.3379-1.8392z",
    fill: "url(#cg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.579 76.103 6.2998 4.3602s-4.4106 7.1982-11.512 2.7385l5.2119-7.0987z",
    fill: "url(#cf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.315 77.997c-0.21685 0.29117-5.4287 7.0581-11.284 7.6773-0.29036 0.029486-0.58073 0.044228-0.86007 0.044228-1.6348-5.069e-4 -3.2248-0.53629-4.5282-1.5259l1.3526-1.8429c1.0826 0.83179 2.4461 1.2073 3.8005 1.0467 4.8884-0.516 9.6629-6.7227 9.7107-6.7854 0.24687-0.32524 0.64802-0.49371 1.0523-0.44195 0.40432 0.051766 0.75039 0.3159 0.90785 0.69291 0.15746 0.37701 0.10237 0.80962-0.14449 1.1349h-0.007351z",
    fill: "url(#cd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.365 61.286c-3.4807 2.1893-7.9575 3.7299-13.776 4.5703-3.8628 0.53803-7.2112 2.9549-8.9462 6.4574 0.66894-1.5591 3.7858-9.6861 1.4224-20.684-0.17524-0.84039 0.17156-1.7039 0.87871-2.1879 0.70715-0.48404 1.6354-0.49331 2.3521-0.023492l18.069 11.868z",
    fill: "url(#cc)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.825 23.22)",
    fill: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.9651 64.286c-0.069957 0-0.13949-0.010932-0.20583-0.033203-0.32994-0.11505-0.50554-0.47546-0.39328-0.80717 4.4474-12.988 8.5603-31.915 2.8926-48.305-3.3668-9.7303-8.6338-13.969-8.6852-14.006-0.27505-0.21679-0.32278-0.61612-0.10659-0.89194 0.21619-0.27582 0.61442-0.32367 0.88947-0.10689 0.22788 0.1806 5.6162 4.515 9.1006 14.592 5.7852 16.733 1.6209 35.954-2.8889 49.134-0.089701 0.25613-0.33208 0.42657-0.60278 0.42389z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.569,
    cy: 57.19,
    rx: 3.0154,
    ry: 4.73,
    fill: "url(#ca)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.14 36.85c-0.79503 0.72966-1.7036 1.2973-2.6824 1.676-0.98198 0.3506-2.0584 0.16384-2.8926-0.50188-0.83421-0.66571-1.3244-1.7291-1.3172-2.8576v-6.2226c-0.007309-0.98724 0.5714-1.866 1.4306-2.1723s1.801 0.030358 2.3282 0.83224c1.606 2.4524 3.1335 5.7074 3.1335 9.2461z",
    fill: "url(#bz)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.345 3.98c-6.192-6.2163-6.0392-3.9962-8.8124-1.1009-2.4944 2.5981-6.6351 4.5063-7.0094 11.049 0 0-0.4431 5.0567-1.6922 6.7117 0 0 3.01-1.8788 3.2927-4.198 0.24065-1.9889 2.5326-2.2018 2.9757-0.62016 0.1322 0.53892 0.62704 0.92375 1.2032 0.93575h0.12223c0.15419 4.68e-4 0.30709-0.026918 0.45074-0.080731 1.1433-0.41728 2.0495-1.2798 2.4944-2.3742 0.28256-0.73023 0.88872-1.3018 1.654-1.5596 4.622-1.6036 9.1562-4.9136 5.321-8.763z",
    fill: "url(#by)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.439 10.031c0.89399-1.2139-4.6861 1.6921-6.6316-0.58121-1.3593-1.5891 0.47997-3.9066 1.7147-5.1499-2.268 2.0489-4.9133 4.3149-5.2064 9.612 0 0-0.42501 5.069-1.6231 6.728 0 0 2.8871-1.8834 3.1583-4.2082 0.23083-1.9938 2.4292-2.2071 2.8542-0.62167 0.1268 0.54023 0.60144 0.92599 1.1541 0.93802h0.11724c0.14789 4.69e-4 0.29455-0.026984 0.43234-0.080928 1.0966-0.41829 1.9658-1.2829 2.3925-2.38 0.27102-0.73201 0.85244-1.305 1.5865-1.5634l0.36639-0.13243c-4.382 1.5376-1.1944-1.3463-0.31509-2.5603z",
    fill: "url(#bx)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.129 169.09c-3.3696 0.23431-6.677-1.2395-6.382-3.3076 0.029218-0.16299-0.023655-0.32906-0.14498-0.45538-0.12132-0.12631-0.29922-0.2005-0.48779-0.20342h-4.4371l2.4573 5.8612c0.26578 0.61535 0.94058 1.0215 1.6925 1.0188h9.2003c0.43093 0.002073 0.83453-0.18438 1.0755-0.49687s0.28754-0.70968 0.12399-1.0584c-0.38044-0.75388-1.2228-1.4908-3.0978-1.3583z",
    fill: "url(#bw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6876 169.53c-3.2381 0.14227 0.66284-2.9064 2.1732-4.0175 0.082241-0.057586 0.11506-0.1584 0.081082-0.24907-0.033976-0.090676-0.1269-0.15028-0.22959-0.14726h-4.868l-4.3465 4.1293c-0.48995 0.46445-0.63316 1.1589-0.36304 1.7604 0.27011 0.60154 0.90055 0.99214 1.5982 0.99018h10.051s1.869-2.7269-4.0965-2.4661z",
    fill: "url(#bv)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(596 215) scale(-1 1) translate(-54 -133)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m76 84.81s7.6468-8.503 14.114-8.7983 5.009-3.1886 3.9775-1.4703-3.7227 9.0758-5.0683 9.3297c-1.3456 0.25391-3.8649 1.6238-7.7061 0.93888",
    fill: "url(#bu)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.31 59h-7.0369c-0.59176 2.633e-4 -1.1393 0.29581-1.4394 0.7771l-9.4773 15.192c-0.40135 0.61433-0.46377 1.3737-0.16762 2.0391s0.91445 1.155 1.6603 1.3146l7.1495 1.6769 10.798-18.663c0.28698-0.49178 0.27511-1.0905-0.031163-1.5718s-0.86071-0.77256-1.4556-0.7648z",
    fill: "url(#bs)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.296 60h5.2772c0.15149-0.0010144 0.29204 0.078563 0.36874 0.20879 0.076707 0.13023 0.077934 0.29135 0.00322 0.42273l-8.0031 14.368h-5.1378c-0.28733-0.0013681-0.55231-0.15477-0.6959-0.40288s-0.14417-0.55357-0.0015351-0.80222l7.8287-13.575c0.07229-0.13205 0.2095-0.21588 0.36034-0.22017z",
    fill: "url(#br)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 84s12.683 24.792 39.33 22.897c26.647-1.8955 32.67-22.897 32.67-22.897h-5.591s-11.944 11.574-25.412 6.9074",
    fill: "url(#bq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92 80.883s1.3602-3.9281 0.69738-7.5399c-0.6628-3.6118 7.3542-11.117 7.3024-8.9604-0.051872 2.1567-2.9336 4.3652-2.7895 5.9065s6.7087 5.3314-2.3054 13.711",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.364 11.344 0.63476 18.339c0.025834 0.76326-0.34037 1.4818-0.95781 1.8794-0.71416 0.46351-1.2333 1.1981-1.4509 2.053-0.60642 2.3643-2.267 7.0269-5.7979 6.0932-4.6757-1.239-8.1329 1.9991-9.323 6.2907l-14.469-6.2129s2.9358-24.714 13.772-29.826c10.836-5.1116 17.592 1.3826 17.592 1.3826z",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 30.992c-0.32217-0.040956-1.5171-0.25159-1.5405-1.0649 0-0.94199-0.87864-7.1381-0.3866-7.2902 0.3456-0.10532 1.2887-0.52073 1.8334-0.76647l-0.35731-9.7476-0.035146-0.035105c-0.076149-0.06436-0.26359-0.22233-0.58576-0.43297l-3.5146-0.42126-14.568-0.23404c-4.7974 2.4398-8.0483 8.4194-10.175 14.317l-0.052718 0.14627c-0.097626 0.27304-0.1933 0.54608-0.28702 0.81912-0.17573 0.51098-0.34169 1.02-0.49789 1.5271l-0.093721 0.29254-0.19916 0.66115-0.12301 0.42126c-0.082006 0.28474-0.16206 0.56754-0.24016 0.84838l-0.16987 0.62019-0.12887 0.47977-0.14644 0.58509-0.10544 0.40956c-0.076149 0.30425-0.14644 0.58509-0.21673 0.89519l-0.064433 0.26914-0.11715 0.6904-0.064434 0.2984c-0.058576 0.26329-0.11129 0.52658-0.16401 0.77232v0.087763l0.29288 5.1605 0.087864 0.093614 13.742 5.6051c1.0719-3.6627 3.9246-6.5354 7.8492-6.4067-0.1933-0.081912-0.43346-0.14042-0.6912-0.25159-6.4433-2.8903-2.8234-16.897 5.2718-14.224 4.5806 1.5154 3.2158 8.7763 3.2158 8.7763 0.095936-0.3341 0.24209-0.65171 0.43346-0.94199 0.18086-0.28551 0.40404-0.54197 0.66191-0.76062 0.12674-0.11159 0.26186-0.2133 0.40417-0.30425 0.32484-0.22221 0.57898-0.53292 0.7322-0.89519z",
    fill: "url(#bp)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.8177 251.21-3.7488 12.62c-0.15538 0.51454-0.044583 1.0679 0.29912 1.4939 0.3437 0.42605 0.8803 0.6752 1.4487 0.67268h10.312c0.3875 0.001255 0.72895-0.23937 0.8367-0.58965 0.10775-0.35028-0.044313-0.72534-0.37262-0.91906l-2.893-1.7015c-1.1053-0.65272-1.567-1.9491-1.1029-3.0968l3.9176-9.693",
    fill: "url(#bo)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.578 48.164c2.9343-0.51924 6.2233-4.2966 9.5808-0.46789 8.4083 9.6031 17.629 32.005 25.208 61.898 9.2434 36.381 10.633 89.857 10.633 140.41h-7.8305s-4.839-63.25-24.132-91.295c0 0-11.337 64.477-24.384 91.295h-7.6532s11.56-51.57 8.3053-93.994c-0.86943-11.241 16.588-39.451 14.008-49.448-2.4824-9.5118-2.3795-16.804-7.0012-23.623",
    fill: "#485BBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.368 108.63c-0.26417-1.0341-0.53222-2.0587-0.80416-3.0737l-36.467-39.555-1.4976 15.788c4.7084 6.8655 4.6035 14.208 7.1326 23.785 2.6514 10.06-15.151 38.493-14.271 49.787 3.3099 42.715-8.4612 94.64-8.4612 94.64h7.8027c13.292-27.002 24.842-91.922 24.842-91.922-1.2645-1.8959-5.0173-8.1524 7.5347-15.317 8.7409-5.004 13.665-19.154 15.821-27.238-0.5128-2.3249-1.0567-4.6229-1.6316-6.8942z",
    fill: "url(#bn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.071 89.868c-0.50892-2.6715-0.98274-5.2743-1.439-7.7857-0.47511-2.7385-0.0662-5.5537 1.1699-8.0545 0.75749-1.5883 1.3835-3.2335 1.8719-4.9197 0.74263-2.4894 0.19918-5.1766-1.4566-7.2022l-9.2132-11.241c-0.087744-0.11441-0.18719-0.22882-0.28078-0.34323l-0.029248-0.034323c-2.6708-3.2762-6.3682-5.6036-10.523-6.6244-0.32173-0.080088-0.58496-0.14301-0.8599-0.18306-9.5992-1.6475-16.174 1.1441-20.983 5.3544-8.0432 7.0363-10.12 18.483-5.5279 28.031 2.7493 5.7205 12.512 12.648 13.454 24.398 0.69611 8.8497-20.257 31.68-21.246 47.246-0.088853 1.5199 0.50862 3.0015 1.6345 4.0529 1.1258 1.0514 2.6667 1.5669 4.2152 1.4102h0.10529l0.8599-0.091529c31.98-3.5925 54.115-33.036 48.248-64.013z",
    fill: "url(#bm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.288 74.136c0.26202-0.54345 0.49555-1.0926 0.712-1.6361-1.8113-2.5342-3.1442-6.6644-4.1239-11.178-0.79963-3.7763-2.4609-7.3148-4.853-10.337l-0.25632-0.32607c-0.08544-0.11441-0.18227-0.22882-0.27341-0.34323l-0.02848-0.040044c-2.595-3.2667-6.1843-5.5895-10.219-6.613-0.31328-0.080088-0.5696-0.14301-0.83731-0.18306-9.3471-1.6475-15.749 1.1441-20.431 5.3544-7.832 7.0363-9.854 18.483-5.3827 28.031 2.6771 5.7206 12.184 12.648 13.101 24.398 0.67782 8.8554-19.731 31.686-20.688 47.257-0.083045 1.518 0.50026 2.9963 1.5961 4.0452s2.5942 1.5629 4.0999 1.4065h0.10253l0.83731-0.091529c5.4881-0.63577 10.846-2.1156 15.886-4.3877-18.706 8.2376-13.67-12.013 5.2004-21.584 18.871-9.5705 11.631-13.941 6.8352-30.319s17.065-4.1588 17.065-4.1588l1.3955-6.9676c-0.26771-1.4816-0.52973-2.9518-0.78035-4.3762-0.49155-2.6947-0.1269-5.4764 1.0424-7.9516z",
    fill: "url(#bl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 251 1.0806 11.277c0.20259 2.1114 1.9842 3.7234 4.1144 3.7227h7.8648c0.41742-8.09e-4 0.78452-0.27506 0.90201-0.67388s-0.042648-0.82706-0.39349-1.0522l-4.1953-2.664c-0.91112-0.57949-1.4624-1.5818-1.462-2.6582v-7.9517",
    fill: "url(#bk)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.981 53.588c-5.043-4.7882-13.45-2.6363-15.384 4.0164-1.9911 6.8555 0.13047 17.829 20.007 32.323 35.562 25.913 46.396-6.3542 46.396-6.3542s-1.4125-4.3263-3.4036-3.9826c0 0-19.78 22.195-34.126-6.0669-5.3096-10.466-9.859-16.477-13.489-19.936z",
    fill: "url(#bj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.668 9.989c1.0115 0.85171 1.7484 1.9772 2.1197 3.2377 0.65803 2.3406 0.16888 5.6818-7.1161 6.901-11.647 1.9553-26.415 13.118-15.793 23.67 0 0-7.8091-3.2147-14.518 6.4927-6.7085 9.7074 1.2404 28.944 9.23 35.465s-36.524 15.412-25.96-31.963c10.447-46.852 24.138-67.762 52.037-43.804z",
    fill: "url(#bh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.646 85.802c-8.0102-6.4624-15.985-25.519-9.2538-35.144s14.555-6.4168 14.555-6.4168c-6.7083-6.5878-3.322-13.409 3.0243-18.042-1.6231 0.9403-3.8592 1.835-4.9509 0.50719-1.8332-2.2225 6.0661-5.6988 4.8517-9.3688-1.2144-3.67-11.805 5.6988-17.48 0-2.6565-2.6727-1.6464-5.7843 0.18099-8.3373-6.9477 8.8103-12.261 24.414-16.931 45.146-10.614 46.929 34.008 38.119 26.004 31.657z",
    fill: "url(#bg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.73 5.295-0.46 0.41 0.46-0.41z",
    fill: "url(#bf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 5c0.93651-0.97561 1.6825-1.7073 2-2-0.65079 0.61463-1.3175 1.2878-2 2z",
    fill: "url(#be)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.505 24.5 41.505 24.5 41.495 24.5",
    fill: "url(#bd)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(419 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.773 107.95h28.237v2.4526c0 1.0303-0.69764 1.8656-1.5582 1.8656h-26.679v-4.3182z",
    fill: "url(#bc)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.787 109.68h-20.521c-1.667-0.001564-3.0561-1.317-3.1991-3.0293l-3.0022-35.954c-0.089569-1.0794 0.26385-2.148 0.97433-2.9461 0.71048-0.79809 1.7129-1.2529 2.7637-1.2529h19.44c1.9473 4.779e-4 3.5707 1.5365 3.738 3.5367l3.0071 36.055c0.075014 0.92343-0.22846 1.8371-0.83679 2.5192-0.60833 0.68216-1.4659 1.0708-2.3647 1.0708z",
    fill: "url(#bb)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.086 109.68h-20.521c-1.667-0.001564-3.0561-1.317-3.1991-3.0293l-3.0022-35.954c-0.089569-1.0794 0.26385-2.148 0.97433-2.9461 0.71048-0.79809 1.7129-1.2529 2.7637-1.2529h19.44c1.9473 4.779e-4 3.5707 1.5365 3.738 3.5367l3.0071 36.055c0.075015 0.92343-0.22846 1.8371-0.83679 2.5192-0.60833 0.68216-1.4659 1.0708-2.3647 1.0708z",
    fill: "url(#ba)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.598 72.545-1.246-14.69c-0.075365-0.88579 0.22092-1.7629 0.81679-2.4179 0.59587-0.65506 1.4367-1.0281 2.3181-1.0284h5.258c1.6335 4.879e-4 2.9952 1.2616 3.1349 2.9033l1.2958 15.233",
    stroke: "url(#az)",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.8297 30.227s-2.2232-3.9729-0.76956-6.2793 2.7339-2.9133 2.5698-1.8512c-0.16408 1.0621 1.9921 5.3689 0.91053 7.3591",
    fill: "#F9AA8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.167 25.415c-1.101 7.3667-2.887 16.195-10.247 5.8975-0.43381-0.60769-0.83465-1.1205-1.2-1.5539l-3.298 0.85385c0.32219 3.3923 2.4532 9.1616 5.4772 12.239 5.7106 5.8154 11.393 1.3897 12.492 0v-27.305s-2.1234 2.4898-3.2244 9.8693z",
    fill: "#FFD087",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0667 29.466-0.13691-0.10264-3.3628 0.78954c0.28522 2.8029 1.9024 7.1875 4.2784 10.438-3.243-5.0241-0.77866-11.125-0.77866-11.125z",
    fill: "url(#ay)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.392 42.855v-27.31s-2.1933 2.502-3.3264 9.8671c-0.48043 3.1301-1.0914 6.5217-2.2115 8.6007-1.7833 6.0397-0.067887 14.53-6.4414 9.6287 5.5693 4.5862 10.904 0.54091 11.979-0.78701z",
    fill: "url(#aw)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "45.351 103.18 47.919 108.82 50.485 108.82 49.697 100.18",
    fill: "#F9AA8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7667 108.61 3.924-5.1711-3.7729-2.3976-2.9727 6.3602s-0.91906 4.1823 2.8216 1.2086z",
    fill: "#F9AA8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.3798 107.09s-8.9342 2.0666-7.1423 2.7379l6.7187 1.5115c0.61738 0.1422 1.276 0.061966 1.8223-0.22201 0.54627-0.28398 0.93246-0.74686 1.0685-1.2807l0.42104-1.6607-2.8882-1.0859z",
    fill: "#FFD087",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.092 19.864s-3.0631 12.614 0.33694 32.342c0.30376 1.777 3.0963 5.7931 11.231 0.21578l-11.568-32.558z",
    fill: "#FFD087",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.072 50.5s-3.6431-9.2519-4.6464-13.353c-2.2032-8.9912-2.4892-17.742 0.12254-23.111 0 0 1.5956-5.4423 8.3253-1.1771l7.7764 49.322-11.578-11.682z",
    fill: "#F5E9CA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.525 12.868c-6.5015-4.2876-8.043 1.1832-8.043 1.1832-1.6229 3.4708-2.0866 8.3513-1.6426 13.797 0.37983 1.4962 1.1025 2.9008 2.4196 3.7354 3.8674 2.4479 5.4853 12.893 3.6996 19.222l4.1041 4.3105c1.9531 0.20331 3.9208 0.20927 5.875 0.017812l-6.4127-42.265z",
    fill: "url(#av)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.344 5.6863-0.47268-3.3273s-3.1157-2.424-8.3697 2.2241c-1.1953 1.0602-2.1778 5.6045-1.6779 7.7856 0.035974 0.31665 0.28355 0.5645 0.59395 0.59461 0.66202 0.05516 1.2477 0.46011 1.5443 1.0678 0.11384 0.25302 0.22026 0.48581 0.30192 0.67811 0.39844 0.94631 0.79688 1.7712 1.3389 1.7433 0.61127-0.030363 1.4849-0.36182 2.4525-0.82486 0.26507-0.12509 0.57422-0.10348 0.82017 0.057337 0.24595 0.16081 0.39482 0.43867 0.39495 0.73716-0.017323 1.9888-0.20788 4.0863-0.10394 5.2705 0.34894 4.0762 7.0704-9.5314 7.0704-9.5314l-0.13611-0.10121c-2.0418-1.5196-3.3965-3.818-3.7567-6.3737z",
    fill: "#F9AA8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.566 20.727c2.0298-2.8731 4.8156-8.6344 4.8156-8.6344l-0.13243-0.10055c-1.9893-1.5082-3.31-3.7918-3.6623-6.3319l-0.45989-3.3055s-3.0314-2.4081-8.1432 2.2095c-0.45748 0.41475-0.88366 1.3699-1.2039 2.5137 0.32502 0.083498 0.66458 0.083498 0.9896 0 0.39247-0.15333-0.63084 2.3452-0.60917 4.1852 0.019262 1.7219-0.41414 1.5886-0.46952 1.5635l0.067418 0.032678c0.05439 0.02057 0.111 0.034077 0.16855 0.040219 0.45866 0.047491 0.88581 0.2651 1.2039 0.61333 0 0-0.72234-5.9071 1.8275-5.7487 2.5499 0.15836 3.4937 3.4814 2.7184 5.7487-0.72234 2.119-1.423 2.5137-1.5097 2.5715 0.06501-0.030164 0.50323-0.23628 1.0907-0.47006l0.14447-0.070382c0.071769-0.035333 0.14797-0.059875 0.22633-0.072896 1.2328-0.45497 2.8581-0.89738 3.289-0.25137 0.72234 1.0683-1.24 2.9988-1.11 3.68 0.13002 0.6812 1.6855-0.34689 1.37 0.52284-0.15587 0.45764-0.36105 0.89531-0.61158 1.3046z",
    fill: "url(#au)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.67 50.091s1.8639 44.356 18.99 54.8c0.51765 0.31224 1.1102 0.47577 1.7134 0.47293h0.58201c0.74651 0 1.4589-0.31531 1.9649-0.8686s0.75952-1.2946 0.6993-2.0447l-4.2145-52.347-19.736-0.012644z",
    fill: "#847AB8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.918 88.038-2.9584-37.194-0.29584-0.75308h-11.562l-0.94423 0.37152-5.6308 10.854c1.0256 8.1408 3.0274 19.291 6.8389 28.501 0 0 5.6037-2.2818 8.9393-7.8671 3.3356-5.5853 5.6136 6.0874 5.6136 6.0874z",
    fill: "url(#at)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.089 105.28c1.0227-0.15173 30.864-23.518 32.261-55.189h-19.622s-12.236 42.775-17.172 53.469c0 0 0.9978 2.2608 4.5325 1.7196z",
    fill: "#9C93C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.089 105.28c1.0227-0.15173 30.864-23.518 32.261-55.189h-19.622s-0.46148 1.6109-1.2472 4.2864c0 0 12.433 1.2062 9.5938 10.803-2.8387 9.5969-17.664 42.209-25.519 38.38 0 0 0.9978 2.2608 4.5325 1.7196z",
    fill: "url(#as)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.382 13.537c-0.33221-0.25293-0.71816-0.45022-1.0675-0.69557-1.6293-1.1508-6.9471-3.622-3.1755 16.582 3.5786 19.223 1.9175 24.406 8.3052 26.601 2.7969 0.96621 10.907-4.659 10.907-4.659s-1.3752-27.013-14.969-37.829z",
    fill: "#FFD087",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.852 36.692c6.0438 4.3729 6.618 14.21 3.1604 17.235s-5.9682-0.79485-5.9682-0.79485c0.84613 1.3788 2.0473 2.2585 3.9184 2.8913 2.8834 0.98263 11.244-4.7382 11.244-4.7382s-0.98967-19.202-9.4963-31.923l-8.4664-2.953s-0.42307 15.9 5.6081 20.283z",
    fill: "url(#ar)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.546 6.5292s1.3998-5.9385 7.8535-6.5083c2.7-0.24535 4.9816 1.6911 4.9816 4.5482 0 0.65059-0.12272 1.2946-0.36116 1.8942l-1.208 3.0365h-0.069742c-0.71521 0.012398-1.3172-0.56414-1.3774-1.3191-0.022505-0.5747-0.38174-1.0732-0.89918-1.2478-1.2454-0.52763-1.7236 1.0342-1.8756 1.7306-0.04045 0.19469-0.20539 0.33179-0.39355 0.32713-0.1168 3.9222e-4 -0.22772-0.054184-0.30278-0.14897-0.075055-0.094783-0.10648-0.21998-0.085785-0.34173 0.19179-1.1212 0.45582-3.7145-1.3575-3.0365-1.5911 0.5519-3.2366 0.90949-4.9044 1.0658z",
    fill: "#D38D7D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.03 108.82h-2.758l-5.9405 4.0953c-0.21559 0.14757-0.30978 0.4183-0.23229 0.66768 0.077493 0.24938 0.30858 0.41919 0.5699 0.41879h7.2413c0.45277-5.8e-4 0.88343-0.19567 1.1823-0.53556 0.29882-0.33989 0.43696-0.79177 0.3792-1.2405l-0.44187-3.4058z",
    fill: "#FFD087",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.619 50.942c-2.6713-9.5731-11.088-23.565-15.798-29.507-3.0636-3.8668-7.2642-6.9885-9.0609-8.2048-1.3419-0.90967-1.7842 0.598-2.249 2.1665-1.3394 4.561 2.6738 11.149 2.6738 11.149l20.923 24.409 3.5109-0.01267z",
    fill: "#FFD087",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.34 50.957s1.6387 4.4454 4.2234 5.0199c2.5847 0.57451 3.8093-0.56745 3.4003-0.82645-0.59587-0.30865-1.2091-0.58689-1.8369-0.83351 0 0 0.56964-3.3623-2.2585-3.3623",
    fill: "#F9AA8F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5249 19.864h-3.0333c-0.20613 3.263e-4 -0.39935 0.097772-0.51856 0.26152-0.11921 0.16375-0.14968 0.37356-0.081756 0.56307l1.7375 4.8074c0.089951 0.24775 0.33047 0.41341 0.60032 0.41349h2.9796c0.20535-8.68e-5 0.39806-0.096582 0.5176-0.25918 0.11954-0.16259 0.15125-0.37134 0.085156-0.56067l-1.6887-4.8074c-0.088001-0.24881-0.32765-0.41645-0.59788-0.41824z",
    fill: "#071C2A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.3272 20.727h-2.1628c-0.14705 7.567e-4 -0.28468 0.07062-0.36953 0.18759-0.084847 0.11697-0.10646 0.26665-0.058042 0.40188l1.2411 3.434c0.06442 0.17624 0.23548 0.29415 0.42757 0.29473h2.1295c0.14686-1.742e-4 0.28461-0.069317 0.36997-0.1857 0.085358-0.11638 0.10784-0.26571 0.060381-0.40106l-1.205-3.434c-0.064155-0.17919-0.23827-0.29876-0.43312-0.29744z",
    fill: "url(#aq)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.448,
    cy: 111.84,
    rx: 2.1392,
    ry: 2.1591,
    fill: "url(#c)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.021,
    cy: 111.41,
    rx: 1,
    ry: 1,
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.335,
    cy: 111.84,
    rx: 2.1392,
    ry: 2.1591,
    fill: "url(#c)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.907,
    cy: 111.41,
    rx: 1,
    ry: 1,
    fill: "#fff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(325)",
    fillRule: "nonzero"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m11.281 66.541s-3.7162-4.625-5.447-7.2706-2.358-12.131 0.13205-10.881c2.4901 1.2493 5.5602 2.2782 4.5934 5.5412-0.96678 3.263 0.38671 4.576-0.50461 4.9826-0.89133 0.40665 2.0185 4.8994 2.0185 4.8994l-0.99979 3.4296",
    fill: "#F7BC86"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 39.655,
    width: 11.211,
    height: 21.552,
    rx: 2.2,
    fill: "#333A3D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.86239,
    y: 41.379,
    width: 8.6239,
    height: 18.966,
    rx: 1.72,
    fill: "#39CE9C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m13.798 61.634s-1.0426-0.92292-0.76288-3.7655c0.27972-2.8426-1.2715-7.3833-1.7928-6.9819-0.5213 0.40147-0.42382 2.6626-0.55097 3.6178-0.12715 0.95522-1.9623 2.7318-0.84765 5.1268 0.4975 1.1887 1.1405 2.2986 1.9114 3.2994l2.0428-1.2967z",
    fill: "#F7BC86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m47.094 42.716s-6.225-0.90019-7.3669 14.8c-1.1178 15.356-13.11 15.116-24.862 4.9319-0.53958-0.46792-1.2917-0.60899-1.9658-0.36869-1.3153 0.47882-3.1655 1.5083-2.3512 3.4332 1.219 2.8729 19.272 25.014 30.181 17.376 10.908-7.6372 19.942-20.791 16.184-32.842-3.7581-12.052-6.6297-12.339-9.8193-7.3308z",
    fill: "#77541D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m69.055 40.517s11.784 3.3006 12.711 11.547c0.92656 8.2468 10.222 11.749 12.109 25.135 1.8876 13.385-18.235 23.97-18.408 15.397-0.1725-8.5739-9.0635-49.793-9.0635-49.793",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m82.651 81.897c-0.78644-0.017342-1.564-0.16119-2.2993-0.42538-0.12279-0.046703-0.18228-0.17864-0.13286-0.29469 0.049417-0.11605 0.18902-0.17227 0.31182-0.12556 0.89734 0.32601 1.8657 0.43864 2.8199 0.328 0.085402-0.021646 0.17647 0.0031155 0.23664 0.064344 0.060172 0.061228 0.079585 0.14888 0.050445 0.22778-0.02914 0.078895-0.10205 0.13609-0.18947 0.14863-0.26225 0.051252-0.52937 0.077011-0.79717 0.076876z",
    fill: "url(#b)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m82.67 82.759c-0.7924-0.017342-1.5759-0.16119-2.3168-0.42538-0.12373-0.046703-0.18366-0.17864-0.13387-0.29469 0.049792-0.11605 0.19046-0.17227 0.31418-0.12556 0.90415 0.32601 1.8799 0.43864 2.8413 0.328 0.12613-0.017956 0.24526 0.059626 0.27139 0.17675 0.026136 0.11713-0.049817 0.233-0.17304 0.264-0.26424 0.051252-0.53338 0.077011-0.80321 0.076876z",
    fill: "url(#ap)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m82.651 84.483c-0.78644-0.017342-1.564-0.16119-2.2993-0.42538-0.12279-0.046703-0.18228-0.17864-0.13286-0.29469 0.049417-0.11605 0.18902-0.17227 0.31182-0.12556 0.89734 0.32601 1.8657 0.43864 2.8199 0.328 0.085402-0.021646 0.17647 0.0031155 0.23664 0.064344 0.060172 0.061228 0.079585 0.14888 0.050445 0.22778-0.02914 0.078895-0.10205 0.13609-0.18947 0.14863-0.26225 0.051252-0.52937 0.077011-0.79717 0.076876z",
    fill: "url(#b)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m82.651 84.483c-0.78644-0.017342-1.564-0.16119-2.2993-0.42538-0.12279-0.046703-0.18228-0.17864-0.13286-0.29469 0.049417-0.11605 0.18902-0.17227 0.31182-0.12556 0.89734 0.32601 1.8657 0.43864 2.8199 0.328 0.085402-0.021646 0.17647 0.0031155 0.23664 0.064344 0.060172 0.061228 0.079585 0.14888 0.050445 0.22778-0.02914 0.078895-0.10205 0.13609-0.18947 0.14863-0.26225 0.051252-0.52937 0.077011-0.79717 0.076876z",
    fill: "url(#a)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m81.789 86.207c-0.78644-0.017342-1.564-0.16119-2.2993-0.42538-0.12279-0.046703-0.18228-0.17864-0.13286-0.29469 0.049417-0.11605 0.18902-0.17227 0.31182-0.12556 0.89734 0.32601 1.8657 0.43864 2.8199 0.328 0.085402-0.021646 0.17647 0.0031155 0.23664 0.064344 0.060172 0.061228 0.079585 0.14888 0.050445 0.22778-0.02914 0.078895-0.10205 0.13609-0.18947 0.14863-0.26225 0.051252-0.52937 0.077011-0.79717 0.076876z",
    fill: "url(#a)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m80.945 87.931c-0.79242-0.017343-1.5759-0.1612-2.3168-0.42541-0.080038-0.030214-0.13681-0.098184-0.14894-0.17831-0.012124-0.080124 0.022244-0.16023 0.090158-0.21014 0.067914-0.049911 0.15906-0.062045 0.23909-0.031832 0.90417 0.32603 1.8799 0.43867 2.8413 0.32802 0.12614-0.017958 0.24526 0.05963 0.2714 0.17676 0.026137 0.11713-0.049818 0.23302-0.17304 0.26402-0.26425 0.051255-0.53339 0.077016-0.80323 0.076881z",
    fill: "url(#an)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m79.202 88.793c-0.78644-0.017342-1.564-0.16119-2.2993-0.42538-0.12279-0.046703-0.18228-0.17864-0.13286-0.29469 0.049417-0.11605 0.18902-0.17227 0.31182-0.12556 0.89734 0.32601 1.8657 0.43864 2.8199 0.328 0.085402-0.021646 0.17647 0.0031155 0.23664 0.064344 0.060172 0.061228 0.079585 0.14888 0.050445 0.22778-0.02914 0.078895-0.10205 0.13609-0.18947 0.14863-0.26225 0.051252-0.52937 0.077011-0.79717 0.076876z",
    fill: "url(#am)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m63.57 50.253s-3.9967-8.1839-11.201-8.5645c-7.2039-0.38065-10.892 5.9619-7.3559 15.773 0 0 1.9076 7.4131 1.9616 8.0554l-0.063752-0.64234s-12.363-13.47-4.7814-22.715 17.282-4.249 20.901 1.9841c0.81237 1.9367 1.0005 4.0668 0.53944 6.1094z",
    fill: "#333A3D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m45.544 44.828s10.892-6.4999 16.547-8.4546c0 0-7.7265-6.5286-6.1321-10.816 1.5944-4.2871 0.30189-22.573-11.099-16.618-11.401 5.955-11.137 13.659-9.6039 15.48 0 0-2.3585 8.2205 5.9435 9.4201 8.302 1.1996 7.2831 6.3422 4.3444 10.988z",
    fill: "#F7BC86"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m40.007 11.871s-1.9719 2.9368 3.6262 4.5259c5.5981 1.5891 5.8493 5.1545 5.8493 5.1545l2.261-6.5374-1.4647-5.5316",
    fill: "url(#al)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m47.102 34.913c2.1011 0.4092 7.3634-1.6561 5.3688 1.3239s7.0342 1.1217 7.0342 1.1217l-3.108-4.973c-1.0811-1.7269-1.1091-3.9077-0.072617-5.6615l-3.4517 2.8548s-5.5722 5.517-12.34 4.2124l0.62451 0.13961 0.22269 0.038513c0.75604 0.10771 1.5035 0.26859 2.2366 0.48142 1.5056 0.28885 2.9918 0.34181 3.4856 0.46216z",
    fill: "url(#ak)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m41.699 68.103s-11.716 63.687 39.105 122.41h2.8477s-28.414-34.796-10.283-109.84l-31.67-12.572z",
    fill: "url(#aj)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.706 102.59)",
    fill: "url(#ai)",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 25.055c0.27596 0.96124 0.56343 1.9321 0.86239 2.9126 1.2813 3.2682 4.2922 8.3292 10.94 10.002 7.7418 1.9225 11.019 11.713 12.133 16.173-2.7991-13.679-4.0015-31.611-0.71455-53.998l-23.22 24.911z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m65.142 50.501s26.122 50.289-15.102 74.575c-23.064 13.582-39.86 68.027-39.86 68.027h-2.4187s6.6997-63.722 32.894-93.663c26.194-29.942-1.4367-53.182 24.487-48.939z",
    fill: "url(#ah)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.771 97.414)",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "10.138 33.314 10.138 33.314 10.142 33.309",
    fill: "url(#ag)",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.532 5.4865-26.237-5.3598c-0.38848 0.47751-0.79142 0.96477-1.2088 1.4618-1.0354 1.2035-2.0419 2.4655-3.0196 3.7714l-4.5848 6.8216-0.038527 0.068216c0.10113-0.024363 9.1165-2.3681 5.519 6.0858-3.5975 8.4539 5.1145 6.6316 8.2978 7.4891 2.3261 0.62856-0.92947 4.3171-2.8655 6.271 1.8395-1.7522 3.8574-3.3022 6.0199-4.6241 10.08-6.0274 16.114-13.643 19.485-21.693l-1.3677-0.29235z",
    fill: "url(#af)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m62.954 39.061s11.517-7.4473 15.914-1.2579 7.1337 16.834 1.9958 14.437c-5.138-2.3967-4.8974-13.156-11.29-7.6808s-6.6195-5.4985-6.6195-5.4985z",
    fill: "#333A3D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m80.837 52.235c2.4397 1.1481 3.1211-0.64215 2.697-3.5269 0.085771 0.8416 0 1.5616-0.31449 1.9848-1.3342 1.6832-4.7651-6.9128-6.2422-8.7565-1.4772-1.8437-6.2613 1.4837-6.2613 1.4837 5.1606-3.0794 5.2892 6.5431 10.121 8.8149z",
    fill: "url(#ad)",
    stroke: "#000",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m73.637 101.31c-1.1598 3.2182-3.6143 7.9996-17.975 2.6423-16.844-6.2913-24.208 10.071-22.451 4.2636 0.35613-1.1808-0.69783-2.7295-0.3802-3.8716 2.3101-8.261 6.7666-7.656 6.7666-27.711 0-36.141 4.4228-31.863 4.4228-31.863l18.288-8.561c18.697 18.714 13.288 59.661 11.329 65.1z",
    fill: "#8A6524"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.22 39.655)",
    fill: "#77541D",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.248 0.48726-0.48378-0.21927-14.513 25.449s7.6098 15.787 2.9027 17.941c-4.7072 2.1537-9.037 3.1574-2.9027 12.181 1.6303 2.3924-6.8067 8.3662-10.159 10.622 3.5896-2.217 9.0176-4.4389 16.071-2.7969l0.73534 0.18516 0.48378 0.1413 0.26124 0.073088 0.62407 0.19978 0.15481 0.048726c0.26124 0.087706 0.5257 0.18191 0.79339 0.28261 1.4755 0.5506 2.8253 0.97451 4.0637 1.3448 0.56118 0.15917 1.0998 0.29885 1.6158 0.41904 0.51603 0.12019 0.99981 0.22251 1.4513 0.30697 1.0423 0.20057 2.0985 0.3195 3.1591 0.3557h0.067729c5.5005 0.11207 6.918-2.8602 7.7404-5.087v-0.024363l0.072567-0.21927 0.053216-0.17541 0.029027-0.10232 0.058053-0.20952 0.048378-0.18516 0.029027-0.11694c1.6594-6.5049 4.4991-31.141-2.7769-50.187-1.7439-4.5385-5.182-8.2095-9.5788-10.228z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m43.119 53.473s1.3182 26.168 34.161 35.32c0 0 4.6932-0.71766 3.6261-7.7691 0 0-29.912-8.7035-31.549-37.921l-3.6406 0.5828",
    fill: "url(#ac)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m55.193 61.207c1.449 5.7775 2.2289 11.703 2.3244 17.659 4.259 3.4913 9.7468 6.681 16.819 9.0646 0.51706-3.159 0.74502-6.3586 0.68105-9.5592-5.7642-2.8336-14.169-8.1893-19.824-17.165z",
    fill: "url(#ab)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m77.368 186.91s3.6158 0.36872 5.3675-2.4258l6.0897 12.92-12.936 0.87329 6.3435-3.4349-4.8649-7.9324z",
    fill: "#291E0B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m7.2776 187.07s2.7368 2.3291 5.6582 1.0201l-1.1837 11.911h-11.752l6.9651-3.8663 0.3125-9.0648z",
    fill: "#291E0B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m41.195 12.354c-1.9668-0.15743-3.697-1.381-4.5253-3.2004-0.80791-1.8567-0.80791-4.3975 2.4045-7.1778 6.4729-5.5409 8.0262 2.3014 8.8582 2.5897 1.7986 0.62543 6.8913 2.8779 9.7911 7.0507 2.8998 4.1728 2.3227 10.07-2.2025 15.108l-1.3369-1.7981s1.9813-2.5164 1.8418-4.6028c-0.13465-1.9935-3.8472-4.3633-5.3909 0.66452-0.11947 0.44446-0.52826 0.74376-0.98103 0.71826-0.17853-0.015886-0.34056-0.11251-0.44126-0.26314-0.1007-0.15063-0.12938-0.33928-0.078112-0.51376 0.59631-1.9838 1.7889-7.4954-3.1162-8.0621-1.8418-0.23454-3.5779-0.40066-4.8234-0.51305z",
    fill: "#000"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m36.916 22.896c0.75842-1.0476-1.2722-0.099562-2.1627 0.16449-0.20499 0.092996-0.44527 0.10357-0.65968 0.029017-0.21441-0.074548-0.38226-0.22702-0.46082-0.41861 0.088315 0.51763 0.32218 1.0073 0.68013 1.4242v0.043288c1.0129-0.15151 2.1285-0.58439 2.6031-1.2424z",
    fill: "url(#aa)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m47.24 37.105c0.099195 0.25503 0.32044 0.44889 0.59465 0.52105 0.2742 0.072154 0.56794 0.013802 0.78946-0.15683 1.221-0.71424 10.875-4.2996 8.621-7.0667 1.1675-0.46592 2.5135-0.20982 3.4059 0.64802 1.9773 1.665 9.2982 7.2323 7.054 11.352-1.0579 1.9299-9.4713-12.383-22.665 6.8397-0.78103 1.1352-1.3643 2.1427-2.2788 3.3442 0 0-1.1963-7.6012 0.093922-9.6683 1.745-2.7907 1.6214-6.4282 3.2428-7.133-0.0049432 0 1.1369 0.86561 1.1419 1.3197z",
    fill: "url(#z)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m71.072 69.828s4.1166 2.6321 6.7844 2.6321c0 0 2.8391 4.0227 0.66082 7.7127 0 0-5.9229-2.4484-8.6641-4.425",
    fill: "#333A3D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m63.548 40.374 1.9935-2.5552s-2.6788-5.3873-5.1131-4.4703c-2.4344 0.91699-0.92007-0.3391-1.5191-1.8626-0.27367-0.72016-0.92857-1.2272-1.6964-1.3134h-0.038336c2.1756 2.794-7.1881 6.4094-8.3573 7.1354-0.17646 0.14947-0.40787 0.21807-0.63761 0.18899-0.22974-0.029076-0.43661-0.15314-0.56998-0.34182 0.37378 0.92655 0.86257 2.8656-0.95841 3.8208-2.4344 1.2991-2.0798 2.2161-0.70443 3.1665 1.3753 0.95043-2.8273 8.444-2.8273 8.444 0.88653-1.2179 1.4376-2.2304 2.2091-3.3766 8.18-12.413 14.482-10.975 18.219-8.8356z",
    fill: "url(#y)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m64.477 42.332c-1.7822-1.9726-4.3934-2.9461-7.0074-2.6125-2.614 0.33365-4.9075 1.9332-6.1548 4.2925-1.1633 2.2642-0.94965 4.7408 1.3058 12.673 6.1253 21.671 2.7018 44.101-9.4348 51.212 0 0-0.87843 4.8518 3.7511 6.7587 0 0 27.317-6.3677 25.408-40.905-1.0304-18.842-4.3636-27.498-7.8679-31.418z",
    fill: "#8A6524"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m46.826 117.24c-6.5207-2.8576-5.3561-10.269-5.3423-10.345l1.599 0.32312-0.79949-0.16156 0.79949 0.15651c-0.041592 0.24739-0.92427 6.0585 4.3487 8.3758l-0.6054 1.6509z",
    fill: "#AD3A07"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m71.331 49.391s-3.9967-8.1839-11.201-8.5645c-7.2039-0.38065-10.892 5.9619-7.3559 15.773 0 0 1.9076 7.4131 1.9616 8.0554l-0.063752-0.64234s-12.363-13.47-4.7814-22.715c7.5815-9.2449 17.282-4.249 20.901 1.9841 0.81237 1.9367 1.0005 4.0668 0.53944 6.1094z",
    fill: "#333A3D"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11)",
    fillRule: "nonzero"
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m99.387 41.333h-13.4c0.14444 0 0.26153 0.11155 0.26153 0.24914v9.9298c-0.0062439 1.9851-1.694 3.5928-3.7779 3.5988h13.403c2.0839-0.0059479 3.7717-1.6137 3.7779-3.5988v-9.9298c0-0.066544-0.027939-0.13032-0.077602-0.17712-0.049662-0.046799-0.11692-0.072726-0.18677-0.072018z",
    fill: "#CCDEF2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m99.387 41.333h-13.4c0.14444 0 0.26153 0.11155 0.26153 0.24914v9.9298c-0.0062439 1.9851-1.694 3.5928-3.7779 3.5988h13.403c2.0839-0.0059479 3.7717-1.6137 3.7779-3.5988v-9.9298c0-0.066544-0.027939-0.13032-0.077602-0.17712-0.049662-0.046799-0.11692-0.072726-0.18677-0.072018z",
    fill: "url(#x)",
    opacity: 0.49,
    stroke: "#000",
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m98.533 39.611h-13.403c0.14444 0 0.26153 0.11152 0.26153 0.24908v9.9279c-0.0046897 1.9868-1.6947 3.5963-3.7808 3.6008h13.403c2.085-0.0059538 3.7732-1.615 3.7779-3.6008v-9.936c-0.0045602-0.13334-0.11862-0.23958-0.25868-0.24096z",
    fill: "#B4CAEF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m98.532 39.611h-13.485c0.14532 0 0.26312 0.11152 0.26312 0.24908v3.7605l3.5664 3.3761c1.3348 1.2654 2.0864 2.9794 2.0906 4.7677v1.6244h4.024c2.0977-0.0059538 3.7962-1.615 3.8009-3.6008v-9.936c-0.0045879-0.13334-0.11934-0.23958-0.26026-0.24096z",
    fill: "#B4CAEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.698,
    width: 71.302,
    height: 44.778,
    rx: 13.09,
    fill: "#CCDEF2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m124.3 0h-4.0297c2.0429 0 3.699 1.6999 3.699 3.7967v37.184c0 2.0969-1.6561 3.7967-3.699 3.7967h4.0297c0.98154 7.685e-4 1.9231-0.3989 2.6174-1.111 0.69432-0.71211 1.0844-1.6783 1.0844-2.6857v-37.184c0-1.0075-0.39011-1.9736-1.0844-2.6857-0.69432-0.71211-1.6359-1.1118-2.6174-1.111z",
    fill: "#B4CAEF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m124.24 0h-63.781c-2.0762 0-3.7592 1.6717-3.7592 3.7339v33.294h71.302v-33.294c0-0.99078-0.39646-1.9409-1.1021-2.6413-0.70562-0.70032-1.6625-1.0934-2.66-1.0926z",
    fill: "#00A887"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m54.98 33.943s2.4882-4.3121 5.3717-5.2127c2.8835-0.90069 2.837 0.36028 1.3953 0.99076-1.4418 0.63048-1.4883 1.458-1.4883 1.458s2.3254 1.8746-2.8632 4.1263",
    fill: "#F9AA8F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m58.216 32.147c-0.53355-0.40323-1.2893-0.37764-1.7924 0.060694-3.0591 2.7081-7.6388 7.7862-8.9801 8.1995-0.3316 0.10116-0.6871-0.026012-1.0546-0.28902l4.2839 7.2428c1.894-0.28902 7.2803-8.5665 8.5679-13.555 0.10731-0.42542-0.043041-0.87298-0.38836-1.1561-0.21111-0.18497-0.42322-0.3526-0.63632-0.50289z",
    fill: "#213330"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m124.3 0h-4.0297c2.0429 0 3.699 1.6717 3.699 3.7339v33.294h4.0325v-33.294c0-0.99078-0.39011-1.9409-1.0844-2.6413-0.69432-0.70032-1.6359-1.0934-2.6174-1.0926z",
    fill: "url(#w)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.698,
    y: 37.028,
    width: 71.302,
    height: 2.5833,
    fill: "#B4CAEF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.06,
    cy: 40.472,
    rx: 1.7181,
    ry: 1.7222,
    fill: "url(#v)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m58.526 121.41h-16.049c-2.2213 2.13e-4 -4.2837-1.1387-5.4476-3.0083s-1.2626-4.2022-0.2608-6.1613l21.658-42.379c0.83849-1.6298 0.75914-3.5733-0.20949-5.1311s-2.6872-2.5059-4.5375-2.5032h-13.84c-1.0272 0-1.8599-0.82285-1.8599-1.8379 0-1.015 0.83269-1.8379 1.8599-1.8379h13.84c3.137 0 6.0494 1.6085 7.6933 4.2487s1.784 5.9341 0.36997 8.7013l-21.658 42.396c-0.41926 0.82022-0.37795 1.7966 0.10912 2.5794s1.3502 1.2599 2.2801 1.2603h16.049c1.0272 0 1.8599 0.82285 1.8599 1.8379 0 1.015-0.83269 1.8379-1.8599 1.8379l0.0028614-0.002828z",
    fill: "url(#u)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m104.92 121.41h-16.05c-2.2211 2.13e-4 -4.2832-1.1387-5.447-3.0084-1.1638-1.8697-1.2625-4.2024-0.26077-6.1616l21.658-42.378c0.8384-1.6299 0.75906-3.5734-0.20947-5.1313-0.96853-1.5579-2.6869-2.506-4.537-2.5033h-13.839c-1.0271 0-1.8597-0.82288-1.8597-1.838s0.8326-1.838 1.8597-1.838h13.839c3.1367 0 6.0487 1.6085 7.6925 4.2489 1.6437 2.6403 1.7838 5.9344 0.36993 8.7017l-21.655 42.395c-0.41921 0.82026-0.37791 1.7967 0.10911 2.5795 0.48702 0.78282 1.35 1.2599 2.2799 1.2604h16.048c1.0271 0 1.8597 0.82288 1.8597 1.838s-0.8326 1.838-1.8597 1.838l0.002861-0.002828z",
    fill: "url(#s)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m38.899 54.25h87.807c0.71428 0 1.2933 0.59554 1.2933 1.3302v1.6452c0 0.73463-0.57904 1.3302-1.2933 1.3302h-87.807c-0.13315 0-0.24168-0.11101-0.24168-0.24795v-3.7922c-0.0041275-0.068736 0.019168-0.1364 0.064902-0.18675 0.045734-0.050357 0.10978-0.078869 0.17678-0.078698z",
    fill: "#3D6FD3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m38.899 54.256h87.399c0.93997 0 1.702 0.7868 1.702 1.7574v0.78496c0 0.97057-0.762 1.7574-1.702 1.7574h-87.399c-0.13316 0-0.24111-0.11146-0.24111-0.24896v-3.8076c0-0.1375 0.10795-0.24896 0.24111-0.24896v0.0058579z",
    fill: "#00A887"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.658,
    y: 54.25,
    width: 59.275,
    height: 4.3056,
    rx: 0.85,
    fill: "url(#r)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m54.98 52.528h23.123c0.51377 0 0.93027 0.65295 0.93027 1.4584v1.1249h-24.054v-2.5833z",
    fill: "#CCDEF2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m38.658 54.492v3.1876l0.2495 0.87571h29.961l2.4341-4.3056h-32.401c-0.13283 0.0015356-0.24058 0.10866-0.2437 0.24228z",
    fill: "url(#q)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m4.1099 72.72s-3.9545 12.276 7.2984 16.315c11.253 4.0382 28.802 1.3801 28.802 1.3801l10.017 23.252h4.7523s-3.7241-27.8-11.944-31.087c-8.2201-3.2873-30.421-13.69-30.421-13.69",
    fill: "#4A567C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m48.966 113.67s0.64316 6.475 0.44198 7.186v0.02127c-0.085035 0.33889-0.0076491 0.69793 0.20952 0.9721 0.21717 0.27417 0.54959 0.43248 0.90001 0.4287h10.419s0.50904-3.5277-1.5241-4.3056-4.4839-1.9385-5.4014-4.3055",
    fill: "#314341"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m40.674 14.508-0.046448 0.25296c-0.42093-2.5685-3.0394-6.2656-10.323-5.0508-7.6204 1.2731-3.3675 12.05-3.1933 15.289 0.17418 3.2384-1.2425 4.6561-1.2425 4.6561l9.9108 0.48368s-0.51964-1.0063 0.30481-2.4517 1.945 0.14455 3.7449-3.0577c0.47092-0.91593 0.77526-1.902 0.89993-2.916 0.054034-0.31303 0.16611-0.61428 0.33094-0.88952 0.55447-0.97847-0.3861-6.3156-0.3861-6.3156z",
    fill: "#F9AA8F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m25.772 18.59v0.080143c0.37432 2.5932 1.0665 5.0376 1.1378 6.3227 0.082413 1.1236-0.065989 2.2519-0.43671 3.3202l6.0486 0.96458s2.2281-3.0998 3.8621-3.3861c1.6339-0.28623 2.8223-6.8694 3.663-7.0125 0.59416-0.10018 0.98928-0.97031 1.1883-1.4998-0.17231-1.6086-0.44562-3.1714-0.44562-3.1714l-0.047533 0.26047c-0.11712-0.69495-0.35835-1.3651-0.713-1.9807l-6.3843-0.4322-7.8727 6.5345z",
    fill: "url(#p)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m65.289 53.39s1.6061-1.1929 1.86-2.8599 2.2822-3.6591 3.275-3.0597c0.40224 0.24155 0.33948 0.77834 0.2539 1.1094-0.047587 0.18453 0.0011736 0.38162 0.12838 0.51889 0.5078 0.55766 1.6746 2.0159 1.2723 3.2267-0.5078 1.5298-2.0768 3.0358-4.5217 3.6472",
    fill: "#F9AA8F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m68.904 54.101c0.23085-0.85088-0.62133-2.0029-1.4219-2.7164-0.80061-0.71345-0.022103-2.2602 0-2.3012-0.29383 0.45836-0.49622 0.9903-0.59186 1.5556-0.21857 1.6287-1.6012 2.8041-1.6012 2.8041l1.9647 2.5292c0.83678-0.22576 1.6285-0.64391 2.3306-1.231 0 0-0.9013 0.20468-0.68027-0.64035z",
    fill: "url(#o)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m11.829 72.244s-3.8833 12.279 7.1698 16.32c11.053 4.0411 39.52 1.8505 39.52 1.8505l9.8369 23.252h4.6639s-3.8154-26.854-11.729-31.087c-7.6846-4.1204-29.884-13.69-29.884-13.69",
    fill: "url(#n)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m74.738 113.67s-0.057282-0.36843-0.16883-1.0153c-0.72356-0.37686-1.4049-0.80998-1.6732-1.2178-0.67834-1.0293-5.2609-16.936-6.6176-19.352s-7.0035-1.4906-7.0035-1.4906l10.486 23.076h4.9775z",
    fill: "url(#m)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m59.275 88.986c-1.0046-2.2955-5.8953-2.8141-10.609-3.8213-4.7135-1.0072-10.004-3.1771-10.412-7.6644-0.35738-3.8213 3.2839-4.2908 4.3814-4.3481l-21.429-0.81885-4.8851 8.3877 4.5249 6.7746c11.56 3.4883 38.428 1.4903 38.428 1.4903z",
    fill: "url(#l)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m42.953 74.058h0.85906s-0.3202-0.011376-0.85906 0z",
    fill: "#91A6C4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m23.195 32.467s0.85346-2.9575 0.98433-4.4835c0.096726-1.1475 8.9756-2.57 14.765 0.88724 0.50398 0.29984 0.70996 0.94607 0.47794 1.4994-0.41251 0.98484-0.81648 2.8599-0.019914 5.7967",
    fill: "#314341"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m16.694 37.438c0.6531-4.4511 3.5267-7.7149 10.124-8.0653 8.2958-0.44019 15.343 0.46915 17.642 6.7273 3.637 9.9042 0.29027 26.403 1.5036 31.876 1.2133 5.4734 0.25253 6.4059-8.5135 5.9946-21.076-0.98752-22.272-0.44598-24.435-1.0454-3.1378-0.86879-1.7416-1.6275 0.2235-8.0855 1.3265-4.3382 2.177-18.786 3.4542-27.402z",
    fill: "#314341"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m44.699 36.793c-2.2558-6.1046-9.1713-6.9916-17.312-6.5622-6.474 0.34181-9.2938 3.5283-9.9346 7.8673-1.239 8.4012-2.0878 22.495-3.3922 26.729-1.6577 5.3871-2.8881 6.7063-1.2874 7.5057 1.5551 0 3.3324-0.016949 5.3404-0.036724 1.2409-0.086381 2.4859-0.098644 3.7283-0.036724 16.283-0.17797 21.02-5.3673 13.469-6.6667-7.5507-1.2994-10.689-6.5198-0.82883-9.9436 9.8606-3.4238 9.345-4.7063 9.345-4.7063l0.92852-2.3673c0.8801-4.2119 1.1963-8.3814-0.056965-11.783z",
    fill: "url(#k)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m37.589 31.096s9.0115 1.4949 13.594 14.537c4.6935 13.356 13.065 5.806 15.36 6.741 2.2955 0.935 1.1378 3.1829 0 3.9192-1.1378 0.73625-11.987 8.9581-22.833-4.6974s-9.3528-21.567-6.1214-20.5z",
    fill: "#314341"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m74.622 113.67c0.91489 2.367 3.3546 3.5277 5.4039 4.3055s1.5248 4.3056 1.5248 4.3056h-10.414c-0.35059 0.00378-0.68317-0.15453-0.90044-0.4287-0.21727-0.27417-0.2947-0.63321-0.20962-0.9721v-0.02127c0.20432-0.711-0.4422-7.186-0.4422-7.186",
    fill: "#314341"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m50.689 52.78c-1.5933-7.5735 0.33322-6.5093 1.7137-4.4518-0.58227-1.0882-1.0722-2.2243-1.4645-3.3962-4.5111-13.186-13.382-14.697-13.382-14.697-3.181-1.0783-4.6623 6.9367 6.0148 20.739 0.86831 1.1325 1.8203 2.1968 2.8478 3.1839l0.89325 0.80659c0.78902 0.67909 1.6319 1.2915 2.5201 1.8311 0.93245 0.22358 1.5961-0.50094 0.85685-4.016z",
    fill: "url(#j)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m26.278 113.61v-15.443h-3.5867v15.443c8.894e-4 1.9416-1.4437 3.5954-3.4061 3.8994l-11.962 1.8587c-0.75386 0.11663-1.3094 0.75156-1.3094 1.4974v0.55154h36.94v-0.55154c0-0.74586-0.55553-1.3808-1.3094-1.4974l-11.962-1.8587c-1.9613-0.30515-3.4044-1.9586-3.4033-3.8994z",
    fill: "#DFECF4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5839,
    cy: 121.85,
    rx: 2.1477,
    ry: 2.1528,
    fill: "url(#h)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.383,
    cy: 121.85,
    rx: 2.1477,
    ry: 2.1528,
    fill: "url(#g)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m25.772 99.028h-3.3026v15.337c-2.597e-4 0.34597-0.045184 0.69039-0.1336 1.0243l3.4336-10.681 0.0026721-5.6801z",
    fill: "#DFECF4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m45.089 98.167h-28.429s-12.738 0.13283-15.628-7.0067c-3.3807-8.3648 2.0455-56.163 9.0522-59.768 7.0067-3.6051 20.298-1.896 21.357-0.048106 1.0584 1.8478-9.4202 58.732 5.9283 58.226l14.71 0.79517s2.6817-0.15847 2.8957 3.8768c0.21397 4.0353-5.566 3.7693-5.566 3.7693l-4.3193 0.15581z",
    fill: "#00A887"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m50.685 90.186-14.069-0.7022c-1.1028 0.049983-2.1939-0.22659-3.1127-0.78899 7.7716 6.7511 17.181 1.4964 17.181 1.4964v-0.0052599z",
    fill: "url(#f)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m52.394 96.319c-0.21682-4.111-2.9343-3.9495-2.9343-3.9495l-14.906-0.81009c-15.556 0.51603-4.9349-57.433-6.0074-59.315-0.98582-1.7297-12.388-3.3326-19.751-0.75531-6.3832 8.7582-10.945 51.603-7.7478 59.54 2.9256 7.2735 15.837 7.1382 15.837 7.1382h28.805l4.3827-0.16162c0.6961 0.015993 1.3919-0.041992 2.0757-0.17297 0.19979-0.47831 0.28397-0.99677 0.24573-1.5135z",
    fill: "url(#e)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m83.436 51.753c-3.3327 0.60962-2.62 2.4968-2.62 2.4968h7.6473c0.24098-0.30481-1.6817-3.1064-5.0273-2.4968z",
    fill: "#DFEAF4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m84.332 51.667c-0.20783 0-0.42127 0.03588-0.64033 0.071759-3.651 0.61322-2.8703 2.5116-2.8703 2.5116h7.6391c0.2303-0.2642-1.3256-2.4137-4.1285-2.5833z",
    fill: "#CCDEF2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.577,
    cy: 5.5972,
    rx: 1.2886,
    ry: 1.2917,
    fill: "#24D1AF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.718,
    cy: 14.208,
    rx: 1,
    ry: 1,
    fill: "#24D1AF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 66.148,
    y: 13.778,
    width: 4.2953,
    height: 1,
    rx: 0.5,
    fill: "#24D1AF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.718,
    cy: 16.792,
    rx: 1,
    ry: 1,
    fill: "#24D1AF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.148,
    y: 16.361,
    width: 4.2953,
    height: 1,
    rx: 0.5,
    fill: "#24D1AF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.718,
    cy: 18.514,
    rx: 1,
    ry: 1,
    fill: "#24D1AF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 66.148,
    y: 18.083,
    width: 4.2953,
    height: 1,
    rx: 0.5,
    fill: "#24D1AF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.718,
    cy: 20.236,
    rx: 1,
    ry: 1,
    fill: "#24D1AF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 66.148,
    y: 19.806,
    width: 4.2953,
    height: 1,
    rx: 0.5,
    fill: "#24D1AF"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.718,
    cy: 21.958,
    rx: 1,
    ry: 1,
    fill: "#24D1AF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 66.148,
    y: 21.528,
    width: 4.2953,
    height: 1,
    rx: 0.5,
    fill: "#24D1AF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m18.727 121.42 2.7499-4.3102c-0.60713 0.75634-1.4143 1.2555-2.2934 1.4183l-11.87 2.1925c-0.74806 0.13757-1.299 0.88655-1.2993 1.7664v0.6506h12.713v-1.7176z",
    fill: "#DFECF4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m28.155 24.066s3.1517-0.41273 5.1661 0 4.0314-2.0891 3.3573-4.1866 0.67145-4.3761 1.2689-2.6205 0.14799 1.8318 0.59745 1.7555 0.58649-2.5612 1.2579-2.7138c0.67145-0.15265 3.5162-1.9788 1.6882-8.4496s-7.4243-4.523-8.4685-2.2615-5.8074 2.0834-7.1256 4.4722c-1.3182 2.3887-1.9294 6.2022 2.2583 14.004z",
    fill: "#F27C1C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m35.583 10.151c-4.7923-0.56878-4.325-2.4126-3.8248-3.2617-1.5725 1.7036-6.1371 1.7171-7.488 3.8251-1.4527 2.2751-2.0966 5.9115 2.48 13.354 0 0 3.4445-0.39356 5.6459 0 2.2015 0.39356 4.4059-1.9921 3.6691-3.9922-0.46425-1.2616-0.047923-2.5932 0.48222-2.9814 0 0 5.3374-6.2026-0.96445-6.9439z",
    fill: "url(#d)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowBannerImage);
export default __webpack_public_path__ + "static/media/workflowBannerImage.4970e653.svg";
export { ForwardRef as ReactComponent };